export async function createFileFromUrl(url: string) {
  try {
    const response = await fetch(url);
    const data = await response.blob();
    const metadata = { type: data.type };
    const filename: string = url.replace(/\?.+/, '').split('/').pop() || '';
    return new File([data], filename, metadata);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }
  return undefined;
}

const MIN_WIDTH = 320;
const MIN_HEIGTH = 320;
const MAX_WIDTH = 1144;
const MAX_HEIGHT = 1144;

function inRange(value: number, a: number, b: number) {
  const min = Math.min.apply(Math, [a, b]);
  const max = Math.max.apply(Math, [a, b]);
  return value >= min && value <= max;
}

export function inWidthSizeImage(size: number) {
  return inRange(size, MIN_WIDTH, MAX_WIDTH);
}

export function inHeightSizeImage(size: number) {
  return inRange(size, MIN_HEIGTH, MAX_HEIGHT);
}

const MIN_HEIGHT_48_PX = 48;

export const sizesTypes = {
  MIN_HEIGHT_48_PX,
};

export function generateFileOfURL(fileURL: unknown) {
  if (fileURL && typeof fileURL === 'string') {
    const url = fileURL;

    const nameArray = url?.split('/');
    const nameString = nameArray[nameArray?.length - 1];

    const file = new File([url], nameString);

    return { name: nameString, file };
  }

  return {};
}

const MIN_WIDTH_250 = 250;
const MIN_HEIGHT_250 = 250;
const MAX_WIDTH_500 = 500;
const MAX_HEIGHT_500 = 500;

export function inWidthBrandImage(size: number) {
  return inRange(size, MIN_WIDTH_250, MAX_WIDTH_500);
}

export function inHeightBrandImage(size: number) {
  return inRange(size, MIN_HEIGHT_250, MAX_HEIGHT_500);
}

export const MIME_TYPES = {
  JPEG: 'image/jpeg',
  PNG: 'image/png',
};
